namespace TabAurous.Production {
    export interface TreeMakingReceiptForm {
        TransId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.LookupEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        Weight: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        NetWeight: Serenity.DecimalEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransTypeId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
    }

    export class TreeMakingReceiptForm extends Serenity.PrefixedContext {
        static formKey = 'Production.TreeMakingReceipt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TreeMakingReceiptForm.init)  {
                TreeMakingReceiptForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = s.DecimalEditor;
                var w6 = s.DateEditor;

                Q.initFormType(TreeMakingReceiptForm, [
                    'TransId', w0,
                    'BagNo', w0,
                    'LotNo', w0,
                    'CertificateNo', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w2,
                    'AttributeId', w0,
                    'ProductTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'Weight', w5,
                    'Line_No', w0,
                    'NetWeight', w5,
                    'Purity', w5,
                    'PureWeight', w5,
                    'CalcOnId', w2,
                    'RefTransItemId', w0,
                    'RefTransTypeId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w6,
                    'CompanyId', w1,
                    'BagStatus', w0
                ]);
            }
        }
    }
}
